import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Loader2 } from "lucide-react";
import { api, errText } from "@/lib/api";

export default function ChannelAccountAccessPage() {
  const location = useLocation();
  const started = useRef(false);
  const [state, setState] = useState({ status: "loading", message: "" });
  const token = new URLSearchParams(location.search).get("verify");

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (!token) {
      setState({ status: "error", message: "This account confirmation link is missing or invalid." });
      return;
    }
    api.post("/channel/support/tickets/verify", { token })
      .then(({ data }) => setState({
        status: "success",
        message: data.identity_status === "verified"
          ? "Your account is confirmed. Cresway Channel Support can now help with account-related support."
          : "Your email is confirmed. Support can still help with your ticket, but no active Channel account is linked to this address.",
      }))
      .catch((error) => setState({ status: "error", message: errText(error) }));
  }, [token]);

  return (
    <main className="min-h-screen bg-[#0A0A0A] px-5 py-10 text-white sm:px-8">
      <div className="mx-auto max-w-2xl">
        <header className="flex items-center justify-between border-b border-white/15 pb-5">
          <a href="/channel" className="font-display text-lg font-extrabold">Cresway Channel</a>
          <Link to="/channel/support" className="inline-flex items-center gap-2 text-sm font-semibold text-white/65 hover:text-white"><ArrowLeft className="h-4 w-4" />Support</Link>
        </header>
        <section className="mt-16 border border-white/15 bg-white/5 p-6 sm:mt-24 sm:p-9" aria-live="polite">
          {state.status === "loading" ? <p className="flex items-center gap-3 text-sm text-white/70"><Loader2 className="h-5 w-5 animate-spin" />Confirming account ownership…</p> : <>
            {state.status === "success" && <CheckCircle2 className="h-9 w-9 text-green-400" />}
            <h1 className="mt-4 font-display text-2xl font-extrabold">{state.status === "success" ? "Account confirmed" : "Unable to confirm account"}</h1>
            <p className="mt-3 text-sm leading-6 text-white/70">{state.message}</p>
            <Link to="/channel/support" className="mt-6 inline-flex border border-white/25 px-4 py-2.5 text-sm font-bold hover:border-[#E62314]">Return to support</Link>
          </>}
        </section>
      </div>
    </main>
  );
}